import React, { useState } from "react";
import "./index.css";


function createNode(type, label) {
  const id = Math.random().toString(36).substr(2, 9);

  if (type === "branch") {
    return {
      id,
      type,
      label,
      children: { true: [], false: [] }
    };
  }

  return {
    id,
    type,
    label,
    children: type === "end" ? {} : { default: [] }
  };
}


function Node({ node, onAdd, onDelete, onEdit }) {
  return (
    <div className={`node node-${node.type}`}>
      <input
        value={node.label}
        onChange={(e) => onEdit(node.id, e.target.value)}
      />

      <div className="actions">
        {node.type !== "end" && node.type !== "branch" && (
          <>
            <button onClick={() => onAdd(node.id, "action")}>+ Action</button>
            <button onClick={() => onAdd(node.id, "branch")}>+ Branch</button>
            <button onClick={() => onAdd(node.id, "end")}>+ End</button>
          </>
        )}

        {node.type !== "start" && (
          <button className="delete" onClick={() => onDelete(node.id)}>
            Delete
          </button>
        )}
      </div>
    </div>
  );
}


function Branch({ node, onAdd, renderNode }) {
  return (
    <div className="branch-container">
      <div className="branch">
        <strong>TRUE</strong>
        <div className="branch-actions">
          <button onClick={() => onAdd(node.id, "action", "true")}>
            + Action
          </button>
          <button onClick={() => onAdd(node.id, "end", "true")}>
            + End
          </button>
        </div>
        {node.children.true.map(renderNode)}
      </div>

      <div className="branch">
        <strong>FALSE</strong>
        <div className="branch-actions">
          <button onClick={() => onAdd(node.id, "action", "false")}>
            + Action
          </button>
          <button onClick={() => onAdd(node.id, "end", "false")}>
            + End
          </button>
        </div>
        {node.children.false.map(renderNode)}
      </div>
    </div>
  );
}


export default function App() {
  const startNode = {
    id: "start",
    type: "start",
    label: "Start",
    children: { default: [] }
  };

  const [nodes, setNodes] = useState({ start: startNode });

  function addNode(parentId, type, branchKey = "default") {
    const newNode = createNode(type, type.toUpperCase());

    setNodes((prev) => {
      const parent = prev[parentId];
      const updatedParent = { ...parent };

      if (parent.type === "branch") {
        updatedParent.children[branchKey].push(newNode.id);
      } else {
        updatedParent.children.default = [newNode.id];
      }

      return {
        ...prev,
        [parentId]: updatedParent,
        [newNode.id]: newNode
      };
    });
  }

  function deleteNode(nodeId) {
    setNodes((prev) => {
      const updated = { ...prev };
      delete updated[nodeId];

      Object.values(updated).forEach((node) => {
        Object.keys(node.children || {}).forEach((key) => {
          node.children[key] = node.children[key].filter(
            (id) => id !== nodeId
          );
        });
      });

      return updated;
    });
  }

  function editNode(id, label) {
    setNodes((prev) => ({
      ...prev,
      [id]: { ...prev[id], label }
    }));
  }

  function renderNode(id) {
    const node = nodes[id];
    if (!node) return null;

    return (
      <div key={id} className="node-wrapper">
        <Node
          node={node}
          onAdd={addNode}
          onDelete={deleteNode}
          onEdit={editNode}
        />

        {node.type === "branch" && (
          <Branch
            node={node}
            onAdd={addNode}
            renderNode={renderNode}
          />
        )}

        {node.children.default &&
          node.children.default.map((childId) =>
            renderNode(childId)
          )}
      </div>
    );
  }

  function saveWorkflow() {
    console.log("Workflow JSON:", nodes);
  }

  return (
    <div className="app">
      <h2>Workflow Builder</h2>
      <button onClick={saveWorkflow}>Save Workflow</button>

      <div className="canvas">
        {renderNode("start")}
      </div>
    </div>
  );
}
